module.exports = __webpack_public_path__ + "static/media/oktayKopru.c7dbfb05.png";